import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: 'home',
    loadComponent: () => import('./home/home.page').then((m) => m.HomePage),
  },
  {
    path: '',
    redirectTo: 'tabs/home',
    pathMatch: 'full',
  },
  {
    path: 'tabs',
    loadChildren: () => import('./tabs/tabs.routes').then( m => m.tabsRoutes)
  },
  {
    path: 'events',
    loadChildren: () => import('./pages/events/events.routes').then( m => m.routes)
  },
  {
    path: 'announcements',
    loadComponent: () => import('./pages/announcements/announcements.page').then( m => m.AnnouncementsPage)
  },
  {
    path: 'settings',
    loadComponent: () => import('./pages/settings/settings.page').then( m => m.SettingsPage)
  },
  {
    path: 'profile',
    loadComponent: () => import('./pages/settings/profile/profile.page').then( m => m.ProfilePage)
  },
  {
    path: 'sermons',
    loadComponent: () => import('./pages/sermons/sermons.page').then( m => m.SermonsPage)
  },
  {
    path: 'registrations',
    loadComponent: () => import('./pages/events/registrations/registrations.page').then( m => m.RegistrationsPage)
  },
  {
    path: 'schedules',
    loadComponent: () => import('./pages/settings/schedules/schedules.page').then( m => m.SchedulesPage)
  },
  {
    path: 'messages',
    loadComponent: () => import('./pages/settings/messages/messages.page').then( m => m.MessagesPage)
  },
  {
    path: 'bible-reading',
    loadComponent: () => import('./pages/bible-reading/bible-reading.page').then( m => m.BibleReadingPage)
  },
  {
    path: 'pastoral-schedules',
    loadComponent: () => import('./pages/settings/pastoral-schedules/pastoral-schedules.page').then( m => m.PastoralSchedulesPage)
  },
  {
    path: 'bank-transactions-details',
    loadComponent: () => import('./components/bank-transactions-details/bank-transactions-details.page').then( m => m.BankTransactionsDetailsPage)
  },
  {
    path: 'first-timer',
    loadComponent: () => import('./pages/first-timer/first-timer.page').then( m => m.FirstTimerPage)
  },
  {
    path: 'transport-request',
    loadComponent: () => import('./pages/transport-request/transport-request.page').then( m => m.TransportRequestPage)
  },
  {
    path: 'bank-transactions-expenses',
    loadComponent: () => import('./components/bank-transactions-expenses/bank-transactions-expenses.page').then( m => m.BankTransactionsExpensesPage)
  },
  {
    path: 'bank-transactions-expense-item',
    loadComponent: () => import('./components/bank-transactions-expense-item_old/bank-transactions-expense-item.page').then( m => m.BankTransactionsExpenseItemPage)
  }
];
